var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-lg pointer",class:'fa-' + _vm.icon,attrs:{"title":_vm.uLang('app.mark_invoice_as_paid', {invoice: this.lang(`app.${this.invoiceType}_invoice`)})},on:{"click":_vm.sendReminder}})
}
var staticRenderFns = []

export { render, staticRenderFns }